import { RecordHistoryActionMenu } from '@/components/audit-log/RecordHistoryMenu'
import { usePathHelper } from '@/hooks/usePathHelper'
import { FeeSettingsForm } from '@/components/fees/FeeSettingsForm'
import { AdminPageHeader } from '@/components/patterns/admin-page'
import IfGlobalOrg from '@/components/organizations/IfGlobalOrg'
import { OrganizationContextNotice } from '@/components/patterns/info-notice'
import { useIsReadOnly } from '@/lib/casl'
import { adminTitleHead } from '@/lib/admin-route-title'
import { feeSettingsQueries, useFeeSettings } from '@/lib/services/fee-settings/fee-settings.query'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { Coins } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/settings/fees/')({
  component: FeeSettingsPage,
  head: () => adminTitleHead('Shop fees', 'Settings'),
  loader: async ({ context, params }) => {
    if (!context.ability.can('list', 'fee-settings')) throw notFound()
    const isReadOnly = !context.ability.can('edit', 'fee-settings')
    if (Number(params.orgId) !== Number(import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID))
      await context.queryClient.ensureQueryData(
        feeSettingsQueries.detail({ organizationId: params.orgId })
      )
    return { isReadOnly }
  },
})

function Settings() {
  const { orgId } = Route.useParams()
  const { isReadOnly } = useIsReadOnly()
  const { data } = useFeeSettings(orgId)
  return (
    <FeeSettingsForm key={orgId} settings={data} organizationId={orgId} isReadOnly={isReadOnly} />
  )
}

function FeeSettingsPage() {
  const path = usePathHelper()
  return (
    <div className="max-w-4xl space-y-5 @container">
      <AdminPageHeader
        icon={Coins}
        title="Shop fees"
        description="Add your own fee to orders. Your shop keeps it."
        actions={
          <IfGlobalOrg show={false}>
            <RecordHistoryActionMenu
              link={path.fees.link('history')}
              triggerLabel="More fee-setting actions"
            />
          </IfGlobalOrg>
        }
      />
      <IfGlobalOrg
        show={false}
        fallback={
          <OrganizationContextNotice>
            Select a florist organization to configure its fee.
          </OrganizationContextNotice>
        }
      >
        <Settings />
      </IfGlobalOrg>
    </div>
  )
}
